import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'panda',
  size: 24,
  node: [
    ['path', { d: 'M11.25 17.25h1.5L12 18z', key: '1wmwwj' }],
    ['path', { d: 'm15 12 2 2', key: 'k60wz4' }],
    ['path', { d: 'M17.902 6.599a8 8 0 0 0-.5-.5', key: '1hpval' }],
    [
      'path',
      {
        d: 'M2 14.5C2 19.47 6.48 22 12 22s10-2.53 10-7.5a10 10 0 0 0-1.3-4.83 4.5 4.5 0 1 0-7.05-5.5 8 8 0 0 0-3.3 0 4.5 4.5 0 1 0-7.04 5.5A10 10 0 0 0 2 14.5',
        key: 'fsvxqb',
      },
    ],
    ['path', { d: 'M6.099 6.599a8 8 0 0 1 .5-.5', key: '1mh6nx' }],
    ['path', { d: 'm9 12-2 2', key: '326nkw' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name Panda
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTEuMjUgMTcuMjVoMS41TDEyIDE4eiIgLz4KICA8cGF0aCBkPSJtMTUgMTIgMiAyIiAvPgogIDxwYXRoIGQ9Ik0xNy45MDIgNi41OTlhOCA4IDAgMCAwLS41LS41IiAvPgogIDxwYXRoIGQ9Ik0yIDE0LjVDMiAxOS40NyA2LjQ4IDIyIDEyIDIyczEwLTIuNTMgMTAtNy41YTEwIDEwIDAgMCAwLTEuMy00LjgzIDQuNSA0LjUgMCAxIDAtNy4wNS01LjUgOCA4IDAgMCAwLTMuMyAwIDQuNSA0LjUgMCAxIDAtNy4wNCA1LjVBMTAgMTAgMCAwIDAgMiAxNC41IiAvPgogIDxwYXRoIGQ9Ik02LjA5OSA2LjU5OWE4IDggMCAwIDEgLjUtLjUiIC8+CiAgPHBhdGggZD0ibTkgMTItMiAyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/panda
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Panda = createLucideIcon(__iconData);

export default Panda;
